import * as React from "react";
import { SVGProps } from "react";
const SvgUserGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 11c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3c0-1.64-1.209-2.907-2.82-2.995L5 11Zm15 4h-8c-1.1 0-2 .9-2 2v9h12v-9c0-1.05-.82-1.918-1.851-1.994L20 15Zm4 4v7h7v-5.3c0-1-.8-1.7-1.7-1.7H24Zm3-2c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 1.64 1.209 2.907 2.82 2.995L27 17Zm-11-4c1.9 0 3.5-1.6 3.5-3.5S17.9 6 16 6s-3.5 1.6-3.5 3.5c0 1.837 1.495 3.393 3.311 3.495L16 13ZM1 21.7V26h7v-7H2.8c-1 0-1.7.8-1.7 1.7l-.1 1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUserGroup;
